import { computed as t } from "vue";
function r(e) {
  const L = {
    LT: "UL",
    RT: "UR",
    LM: "CL",
    RM: "CR",
    LB: "LL",
    RB: "LR"
  };
  return t(() => e in L ? L[e] : e);
}
export {
  r as u
};
//# sourceMappingURL=useDevicePosition.CNFcvGt1.js.map
